import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { motionOpacityVariant } from 'nike-ui/src/common/util';
import useDialogBodyBlockScroll from '@/ui/dialogs/useDialogBodyBlockScroll';
import PopupNg from '@/ui/PopupNg';
import InfoCircleIcon from 'nike-ui/src/icons/svg/info-circle-icon-sv.svg';
import { SvgIcon } from 'nike-ui/src/icons/SvgIcon';

const ReturnReasonDialog = ({ top, showArrowIcon, reason }) => {
    const [overlay, setOverlay] = useState(true);
    useDialogBodyBlockScroll();

    function close() {
        setOverlay(false);
        setTimeout(() => {
            PopupNg.dispatcher.close();
        }, 200);
    }

    return (
        <div className="dialog">
            <AnimatePresence>
                {overlay && (
                    <motion.div
                        key="backdrop"
                        variants={motionOpacityVariant}
                        initial="initial"
                        animate="enter"
                        exit="exit"
                        className="backdrop"
                        onClick={close}
                    />
                )}
                <>
                    <button
                        className="info-modal bg-white br-radius-circle p-abs padding-6 flex"
                        style={{ top: `${top - 6}px`, right: showArrowIcon ? '49px' : '20px' }}
                    >
                        <InfoCircleIcon />
                        <span className="info-modal-arrow p-abs" style={{ right: '7px' }} />
                    </button>
                    <div
                        className="br-radius-xs p-abs bg-white padding-20 ml-32"
                        style={{ top: `${top + 35}px`, right: showArrowIcon ? '40px' : '15px' }}
                    >
                        <div className="flex justify-end">
                            <button className="btn-no-pad filter-hover" onClick={close}>
                                <SvgIcon imgId="close" sizeX="12" sizeY="12" className="c-black-50" />
                            </button>
                        </div>
                        <div className="c-black-40 pt-10 text-normal info-icon-modal-reason">{reason}</div>
                    </div>
                </>
            </AnimatePresence>
        </div>
    );
};

export default ReturnReasonDialog;
